import { styled, css } from 'styled-components';

interface StyledCodeFieldContainerProps {
  $error?: boolean;
  $maxHeight?: number;
  $minHeight?: number;
}

export const StyledCodeFieldContainer = styled.div<StyledCodeFieldContainerProps>`
  min-height: ${({ $minHeight }) => `${$minHeight}px`};
  max-height: ${({ $maxHeight }) => `${$maxHeight}px`};
  display: flex;

  .cm-editor {
    border-radius: 8px;
    border: 1px solid ${({ $error, theme }) => $error && theme.colors.critical100};
    background: ${({ theme }) => theme.colors.grey00_7};
    overflow: hidden;
    flex: auto;
    outline: none;

    .cm-gutters {
      ${({ theme }) => css`
        background-color: ${theme.colors.grey05_2};
        color: ${theme.colors.black_1};
        border-color: ${theme.colors.grey30_1};
      `}
    }

    &.cm-focused {
      ${({ theme, $error }) => ($error ? theme.shadows.error : theme.shadows.focus)};
      border-color: ${({ theme, $error }) => !$error && theme.colors.main};
    }

    &:not(.cm-focused) {
      &:hover {
        border-color: ${({ theme, $error }) => !$error && theme.colors.grey70_1};
      }

      &:not(:hover) {
        border-color: ${({ theme, $error }) => !$error && theme.colors.grey30_1};
      }
    }
  }
  .cm-content {
    caret-color: ${({ theme }) => theme.colors.black_1};
  }
  ${({ theme: { themeId, colors } }) =>
    themeId === 'primaryDark' &&
    css`
      //violet: keyword, local variable
      .cmt-keyword {
        color: ${colors.purple120};
      }
      //blue: atom, bool, url, label, variable/property definition
      .cmt-name {
        color: ${colors.lightBlue120};
      }
      //darkblue: class, special variable, macro
      .cmt-class {
        color: ${colors.lightBlue100};
      }
      //red: string, regexp, escape
      .cmt-string {
        color: ${colors.coral120};
      }
      //green: literal, number, inserted
      .cmt-literal {
        color: ${colors.green120};
      }
      //darkgreen: type, namespace
      .cmt-type {
        color: ${colors.green100};
      }
    `}
`;
